module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat2tone_MidnightGray.ecb1fc90.png";